/* Casa Lizette — discreet scroll-reveal via IntersectionObserver. No scroll-event polling. */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var nodes = document.querySelectorAll('[data-reveal]');
    if (!nodes.length || prefersReduced) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    nodes.forEach(function (node, i) {
      node.style.setProperty('--reveal-index', i % 6);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    nodes.forEach(function (node) { observer.observe(node); });
  });
})();
